import gsap from 'gsap';

export default class Tools {
    static lazy() {
        const images = document.querySelectorAll('img[data-src]');
        images.forEach(e => {
            if (!e.classList.contains('lazy')) {
                e.src = e.dataset.src;
            }
        });
    }

    static offset(el) {
        const rect = el.getBoundingClientRect();

        return {
            top: rect.top + window.pageYOffset,
            bottom: rect.bottom + window.pageYOffset,
            left: rect.left + window.pageXOffset,
            right: rect.right + window.pageXOffset,
        };
    }

    static customInputFile() {
        const formInputs = document.querySelectorAll('input[type="file"]');
        formInputs.forEach(item => {
            item.addEventListener('change', this.editCustomInputFileName);
        });
    }

    static editCustomInputFileName(input) {
        if (input.currentTarget.dataset.maxsize < input.currentTarget.files[0].size) {
            alert('Le fichier est trop volumineux');
            input.currentTarget.value = '';
        } else {
            input.currentTarget.nextElementSibling.innerHTML = input.currentTarget.files[0].name;
        }
    }

    static fromAuto($element, height, duration = 0.85, ease = 'power4.inOut') {
        $element.style.height = 'auto';
        const autoHeight = $element.offsetHeight;

        return gsap.fromTo($element, {
            height: autoHeight,
        }, {
            height,
            ease,
            duration,
        });
    }

    static autoToFixed($element, height = 0, duration = 0.85, ease = 'power4.inOut') {
        return this.fromAuto($element, height, duration, ease);
    }

    static fixedToAuto($element, height = 0, duration = 0.85, ease = 'power4.inOut') {
        const curHeight = $element.offsetHeight;
        $element.style.height = 'auto';
        const autoHeight = $element.offsetHeight;
        $element.style.height = curHeight;

        return gsap.fromTo($element, {
            height: height,
        }, {
            height: autoHeight,
            ease,
            duration,
            onComplete: () => {
                $element.style.height = 'auto';
            },
        });
    }

    static freeScroll() {
        const scrollY = document.body.style.top;
        document.body.classList.remove('js-fixed');
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }

    static freezeScroll() {
        const offset = window.pageYOffset;
        document.body.classList.add('js-fixed');
        document.body.style.top = `-${offset}px`;
    }

    static setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    static getCookie(cname) {
        let name = cname + '=';
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }
}